<script>
  import Select from "svelte-select";

  export let options = [];
  export let value;
  export let label;

  function handleSelect(event) {
    value = event.detail;
  }
</script>

<div class="select-row">
  <div class="select-label">{label}</div>
  <div class="select-container wide-list">
    <Select items={options} {value} on:select={handleSelect} isMulti={true} />
  </div>
</div>

<style>
  .select-row {
    margin-bottom: 4px;
  }
  .select-label {
    width: 100px;
    float: left;
    line-height: 1.5;
  }
  .select-container {
    --border: 1px solid #b0b0b0;
    --borderRadius: 3px;
    --placeholderColor: #cccccc;
    --height: 30px;
    --clearSelectTop: 8px;
    --internalPadding: 0 6px;
    --multiItemBorderRadius: 3px;
    --multiItemHeight: 24px;
    --multiClearTop: 2px;
    --multiItemPadding: 2px;
  }
</style>
